// import { AppSkinInfo, CSInterface, RGBColor } from "../types/CSInterface";

export async function evalScript(csInterface: any, script: any) {
    let res = await new Promise((resolve, reject) => {
        // console.log("executing evalscript")
        csInterface.evalScript(script, function (result) {
            if (result !== "null") {
                resolve(result)
            } else {
                resolve(null)
            }
        })
    })
    return res
}


export function updateThemeWithAppSkinInfo(appSkinInfo: any) {
    var panelBackgroundColor = appSkinInfo.panelBackgroundColor.color;
    var isPanelThemeLight = panelBackgroundColor.red > 127;
    if (isPanelThemeLight) {
        var isPanelThemeMediumLight = panelBackgroundColor.red < 213;
        if (isPanelThemeMediumLight) {
            document.getElementById("themeStyle")?.setAttribute("href", "assets/css/light.css");
        } else {
            document.getElementById("themeStyle")?.setAttribute("href", "assets/css/mediumLight.css");
        }
    } else {
        var isPanelThemeMediumDark = panelBackgroundColor.red > 52;
        if (isPanelThemeMediumDark) {
            document.getElementById("themeStyle")?.setAttribute("href", "assets/css/dark.css");
        } else {
            document.getElementById("themeStyle")?.setAttribute("href", "assets/css/mediumDark.css");
        }
    }
}